export var EFormStatus = /*#__PURE__*/function (EFormStatus) {
  EFormStatus["QuestionEnter"] = "questionEnter";
  EFormStatus["QuestionEdited"] = "questionEdited";
  EFormStatus["QuestionSubmitted"] = "questionSubmitted";
  return EFormStatus;
}({});